export enum SkuType {
	Discount = 'DISCOUNT',
	Promotion = 'PROMOTION',
	Final = 'FINAL'
}
